module.exports = "https://assets.bwbx.io/s3/reg2/images/credit-card-icon-f6b0f202eafdd7c5b373.svg";